import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";
import { saveAxiosFile } from "../utils/download";

async function unwrap(request) {
  const response = await request;
  return unwrapApiResponse(response);
}

function buildContentFormData({ title, description, classSubjectIds, contentType, linkUrl, file }) {
  const formData = new FormData();
  formData.append("title", title);

  if (description) {
    formData.append("description", description);
  }

  classSubjectIds.forEach((classSubjectId) => {
    formData.append("classSubjectIds", classSubjectId);
  });

  formData.append("contentType", contentType);

  if (contentType === "link") {
    formData.append("linkUrl", linkUrl);
  } else if (file) {
    formData.append("file", file);
  }

  return formData;
}

async function downloadFile(request, fallbackName) {
  const response = await request;
  saveAxiosFile(response, fallbackName);
}

export const classContentAPI = {
  getAll: (params) => unwrap(apiClient.get("/teacher/class-contents", { params })),

  getById: (id) => unwrap(apiClient.get(`/teacher/class-contents/${id}`)),

  create: (data, { onUploadProgress } = {}) =>
    unwrap(
      apiClient.post("/teacher/class-contents", buildContentFormData(data), {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      })
    ),

  delete: (id) => unwrap(apiClient.delete(`/teacher/class-contents/${id}`)),

  publish: (id) => unwrap(apiClient.post(`/teacher/class-contents/${id}/publish`)),

  download: (id, filename = "class-content") =>
    downloadFile(
      apiClient.get(`/teacher/class-contents/${id}/download`, {
        responseType: "arraybuffer",
      }),
      filename
    ),

  fetchBlob: async (id) => {
    const response = await apiClient.get(`/teacher/class-contents/${id}/download`, {
      responseType: "blob",
    });
    return response.data;
  },
};
